import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent, ConfirmDialogComponent } from '@app/shared/components';
import { Observable } from 'rxjs/internal/Observable';

/**
 * NotifyOptions
 */
interface NotifyOptions {
  title?: string;
  content?: string;
  confirmBtnText?: string;
  closeBtnText?: string;
}

/**
 * NotificationService
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  /**
   * constructor
   * @param {MatDialog} dialog
   */
  constructor(private dialog: MatDialog) {}

  /**
   * error
   * @param {NotifyOptions} options
   */
  error(options: NotifyOptions): void {
    this.dialog.open(AlertDialogComponent, {
      disableClose: true,
      closeOnNavigation: false,
      id: 'error-alert-dialog',
      panelClass: 'error-alert-dialog',
      width: '364px',
      maxWidth: '90vw',
      data: {
        ...options,
      },
    });
  }

  confirm(options: NotifyOptions) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      closeOnNavigation: false,
      id: 'error-alert-dialog',
      panelClass: 'error-alert-dialog',
      width: '364px',
      maxWidth: '150vw',
      data: {
        ...options,
      },
    });

    if (dialogRef) return dialogRef.afterClosed();
  }
}
